<template>
  <form ref='replyRecordMessageForm' @submit.prevent='submitReply' class="send-reply">
    <div class="form-group">
      <label for="record_message_reply_contacts">{{ $t('record_message.reply_to_label')}}:</label>
      <multi-select v-model="selectedAddressBook" :options='messageAddressBook' />
    </div>
    <div class="form-group">
      <label for="record_message_reply_body">{{ $t('record_message.message_label')}}:</label>
      <input type="hidden" id='record_message_reply_body' name="record_message_reply[body]" v-model="recordMessageBody" />
      <trix-editor input="record_message_reply_body" class="trix-body tinymce form-control"></trix-editor>
    </div>
    <div class="form-group float-right">
      <button class="btn btn-outline-danger m-r-10" :disabled="isProcessing" @click.prevent="close()">
        {{ $t('record_show.cancel') }}
      </button>
      <button type="submit" class="btn btn-outline-primary submit-note" :disabled="isProcessing || recordMessageBody == '' || Object.keys(selectedAddressBook).length === 0">
        {{$t('record_message.reply')}}
        <i class="fas fa-circle-notch fa-spin" v-show="isProcessing"></i>
      </button>
    </div>
  </form>
</template>

<script>
  import _modal from '../../components/_modal'
  import _multi_select from "../../components/shared/_multi_select"
  import 'trix'
  import 'trix/dist/trix.css'

  export default {
    components: {
      'multi-select': _multi_select,
      'modal': _modal
    },
    data() {
      return {
        recordMessageBody: '',
        selectedAddressBook: [],
        isProcessing: false
      }
    },
    mounted(){
      document.addEventListener("trix-change", this.setTextToTrix)
    },
    beforeDestroy() {
      document.removeEventListener("trix-change", this.setTextToTrix)
    },
    props: {
      message: {
        type: Object,
        required: true
      },
      replyMessage: {
        type: Object,
        required: true
      },
      addressBook: {
        type: Array,
        required: true
      },
      resourceType: {
          type: String
      }
    },
    computed: {
      selectedFromMessage(){
        return this.addressBookCollection.selected || []
      },
      messageAddressBook(){
        return this.addressBookCollection.collection || []
      },
      addressBookList(){
        return (this.$props.addressBook || []).map( (item) => { return { id: item.id, name: item.name } }, [])
      },
      addressBookCollection(){
        let addressBook = this.addressBookList
        let message = this.$props.message || {}
        let currentUser = this.currentUser
        let reply = this.$props.replyMessage
        let from_user = reply.from_user || null
        let from_contact = reply.from_contact || null
        let sent_message = reply.sent_message || null
        let selected = []
        let id = null
        let to_user = null
        let to_contact = null

        if(Object.keys(reply).length > 0){
          if(from_user && from_user.id){
            id = from_user.id+'-User'
            if(this.listIncludes(addressBook, id))
              addressBook.push({id: id, name: this.formatName(from_user.full_name, from_user.email)})

            selected = selected.concat(this.selectAddress(addressBook, id))
          }

          else if(from_contact && from_contact.id){
            id = from_contact.id+'-Contact'
            if(this.listIncludes(addressBook, id))
              addressBook.push({id: id, name: this.formatName(from_contact.name, from_contact.email)})

            selected = selected.concat(this.selectAddress(addressBook, id))
          }

          else if(from_user && from_user.id === currentUser.id)
            return []

          else if(sent_message){
            to_user = sent_message.to_user
            if(to_user && to_user.id){
              id = to_user.id+'-User'
              if(this.listIncludes(addressBook, id))
                addressBook.push({id: id, name: this.formatName(to_user.full_name, to_user.email)})

              selected = selected.concat(this.selectAddress(addressBook, id))
            }

            to_contact = sent_message.to_contact
            if(to_contact && to_contact.id){
              id = to_user.id+'-Contact'
              if(this.listIncludes(addressBook, to_contact.id+'-Contact'))
                addressBook.push({id: id, name: this.formatName(to_contact.name, to_contact.email)})

              selected = selected.concat(this.selectAddress(addressBook, id))
            }
          }

        }else{
          if(Object.keys(message).length > 0){
            // no replies, so add or select all sent messages not current user
            from_user = message.from_user
            from_contact = message.from_contact

            if(from_user && from_user !== undefined){
              let id = from_user.id+'-User'

              if(this.listIncludes(addressBook, id) && from_user.id != currentUser.id)
                addressBook.push({id: id, name: this.formatName(from_user.full_name, from_user.email)})

              selected = selected.concat(this.selectAddress(addressBook, id))

            }

            if(from_contact && from_contact !== undefined){
              let id = from_contact.id+'-Contact'

              if(this.listIncludes(addressBook, id) && from_contact.id != currentUser.id)
                addressBook.push({id: id, name: this.formatName(from_contact.name, from_contact.email)})

              selected = selected.concat(this.selectAddress(addressBook, id))

            }
          }

          if(Object.keys(message).length > 0 && message.sent_messages !== undefined){
            message.sent_messages.map( (item) => {
              to_user = item.to_user
              to_contact = item.to_contact

              if(to_user !== undefined && to_user.id){
                let id = to_user.id+'-User'

                if(this.listIncludes(addressBook, id) && to_user.id != currentUser.id)
                  addressBook.push({id: id, name: this.formatName(to_user.full_name, to_user.email)})

                selected = selected.concat(this.selectAddress(addressBook, id))
              }
              if(item.to_contact !== undefined){
                let id = to_contact.id+'-Contact'

                if(to_user && this.listIncludes(addressBook, id) && to_user.id != currentUser.id)
                  addressBook.push({id: id, name: this.formatName(to_contact.name, to_contact.email)})

                selected = selected.concat(this.selectAddress(addressBook, id))
              }
            })
          }

          let replies = message.replies || []
          if(Object.keys(replies).length > 0){

            replies.map( (item) => {

              let sent_messages = item.sent_messages || []
              sent_messages.map( (sent_message) => {
                     to_user = sent_message.to_user || null
                     to_contact = sent_message.to_contact || null

                     if(to_user){
                       let id = to_user.id+'-User'

                       if(this.listIncludes(addressBook, id) && to_user.id != currentUser.id)
                         addressBook.push({id: id, name: this.formatName(to_user.full_name, to_user.email)})

                       selected = selected.concat(this.selectAddress(addressBook, id))
                     }

                     if(to_contact){
                       let id = to_contact.id+'-Contact'

                       if(this.listIncludes(addressBook, id) && to_contact.id != currentUser.id)
                         addressBook.push({id: id, name: this.formatName(to_contact.name, to_contact.email)})

                       selected = selected.concat(this.selectAddress(addressBook, id))
                     }
              })
            })
          }
        }

        this.selectedAddressBook = selected

        return { collection: addressBook, selected: selected }
      }
    },
    methods: {
      open() {
        this.$refs.modal.open(this.selectedFromMessage)
        this.recordMessageBody = ''
      },
      setTextToTrix: function() {
        this.recordMessageBody = document.getElementById("record_message_reply_body").value
      },
      formatName(name, email){
        if(email)
          return `${name} <${email}>`
        else
          return name
      },
      listIncludes(list, id){
        return !list.map( (item) => { return item.id }).includes(id)
      },
      selectAddress(list, id){
        return list.filter( (item) => { return item.id === id })
      },
      close() {
        this.$emit('success')
      },
      submitReply(e){
        let message = this.$props.message
        let params = new FormData(e.target)
        let contact_ids = []
        let user_ids = []

        params.append('record_message_reply[record_message_id]', message.id)

        this.selectedAddressBook.forEach(function (item) {
          let index = item.id.split('-')
          let id = index[0]
          let resource = index[1]
          if(resource === 'Contact'){
            params.append('record_message_sent[contact_ids][]', id)
            contact_ids.push(id)
          }
          if(resource === 'User'){
            params.append('record_message_sent[user_ids][]', id)
            user_ids.push(id)
          }
        })

        if(contact_ids.length > 0 || user_ids.length > 0){
          this.store.createReplyRecordMessage(message.record_id, message.id, params).then(() => {
            e.target.reset()
            this.$toastr.success(this.$t('record_message.message_successfully_replied'))
            this.close()
            this.sendMetricComponent('send_reply')
          }).finally(() => {
            this.isProcessing = false
          })
        }
      },
      sendMetricComponent(name){
        let metric_name = 'file_communication_record_modal_'+name

        if(this.$props.resourceType == 'RecordMessageShow')
          metric_name = 'file_communication_show_'+name

        this.store.sendMetrics({name: metric_name, params: this.$route.params, path: this.$route.fullPath})
      }
    }
  }
</script>
<style lang="sass" scoped>
  .custom-select
    display: block
  .trix-body
    height: 350px
    overflow-y: auto
    margin-bottom: 1rem
  .modal-dialog
    max-width: 560px
</style>
